"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Rect = exports.Path = exports.Icon = exports.G = exports.Circle = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var iconMixin = (0, _styledSystem.compose)(_styledSystem.space, _styledSystem.position);
/** Wrapper for icons to include space */

var Icon = _styledComponents.default.svg.withConfig({
  displayName: "Icon",
  componentId: "sc-1eovgys-0"
})(["position:relative;", ""], iconMixin);

exports.Icon = Icon;
Icon.defaultProps = {
  fill: "black100",
  height: "18px",
  width: "18px"
};
/** Compatibility component used to normalize paths between react dom and react native */

var Path = function Path(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react.default.createElement("path", props);
};

exports.Path = Path;
Path.displayName = "Path";
/** Compatibility component used to normalize titles between react dom and react native */

var Title = function Title(_ref2) {
  var props = _extends({}, _ref2);

  return /*#__PURE__*/_react.default.createElement("title", props);
};

exports.Title = Title;
Title.displayName = "Title";
/** Compatibility component used to normalize svg groups between react dom and react native */

var G = function G(_ref3) {
  var props = _extends({}, _ref3);

  return /*#__PURE__*/_react.default.createElement("g", props);
};

exports.G = G;
G.displayName = "G";
/** Compatibility component used to normalize svg circles between react dom and react native */

var Circle = function Circle(_ref4) {
  var props = _extends({}, _ref4);

  return /*#__PURE__*/_react.default.createElement("circle", props);
};

exports.Circle = Circle;
Circle.displayName = "Circle";
/** Compatibility component used to normalize svg rects between react dom and react native */

var Rect = function Rect(_ref5) {
  var props = _extends({}, _ref5);

  return /*#__PURE__*/_react.default.createElement("rect", props);
};

exports.Rect = Rect;
Rect.displayName = "Rect";